import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { JiraIcon } from '@atlaskit/temp-nav-app-icons/jira';

import { Products } from '../../constants';
import type { GlobalShortcutsItem } from '../../types';

import { messages } from './messages';

export default function jira(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <JiraIcon size="20" />,
		label: <FormattedMessage {...messages.label} />,
		apsKey: Products.JIRA_SOFTWARE,
		fallbackUrl,
	};
}
